import {
  POSTING_SOURCE_IDS,
  POSTING_SOURCE_LABELS,
} from '@revelio/data-access';

import { staticListWithDefaultSelection } from '../engine/default-handlers';
import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

/**
 * One option, from the shared id and label tables. `value` is a string because
 * the engine's static lists are string-keyed all the way to
 * `getPostingFilters`, which parses it back.
 */
const option = (key: keyof typeof POSTING_SOURCE_IDS) => ({
  value: String(POSTING_SOURCE_IDS[key]),
  label: POSTING_SOURCE_LABELS[POSTING_SOURCE_IDS[key]],
});

export const defaultPostingSource = { ...option('unified'), limit: 1 };

/**
 * Display order — the page's own, not the id order, and the one place a new
 * source must be added BY HAND. dash-meta derives its list from
 * `POSTING_SOURCE_LABELS`, so a source added there and not here is one the
 * assistant can quote a figure for and this page cannot show.
 */
export const POSTINGS_SOURCE_OPTIONS = [
  defaultPostingSource,
  option('otherWebsitePostings'),
  option('revelioWebsitePostings'),
  option('linkedIn'),
  option('indeed'),
];

export const postingsSourceDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.POSTINGS_SOURCE,
    name: 'Posting Source',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
  handler: staticListWithDefaultSelection(defaultPostingSource),
});
